import * as actionTypes from "../actions/actionTypes/locationActionTypes";
import initialState from "../initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    /** *********************************************************************** */
    case actionTypes.EMPLOYEE_LIST_BUSINESS_FETCH_REQUEST_NZ:
      return {
        ...state, loadingBusinessEmployees: true, businessId: action.businessId,
      };
    case actionTypes.EMPLOYEE_LIST_BUSINESS_FETCH_SUCCESS_NZ:
      return {
        ...state,
        businessEmployees: action.payload || [],
        loadingBusinessEmployees: false,
        businessId: action.businessId,
      };
    case actionTypes.EMPLOYEE_LIST_BUSINESS_FETCH_FAILURE_NZ:
      return {
        ...state, error: true, loadingBusinessEmployees: false, businessEmployees: [],
      };
      /** *********************************************************************** */
    case actionTypes.EMPLOYEE_LIST_BUSINESS_LOCATION_FETCH_REQUEST_NZ:
      return {
        ...state, locationEmployees: null, loadingLocationEmployees: true, businessId: action.businessId,
      };
    case actionTypes.EMPLOYEE_LIST_BUSINESS_LOCATION_FETCH_SUCCESS_NZ:
      return {
        ...state,
        locationEmployees: action.payload || [],
        loadingLocationEmployees: false,
        businessId: action.businessId,
      };
    case actionTypes.EMPLOYEE_LIST_BUSINESS_LOCATION_FETCH_FAILURE_NZ:
      return {
        ...state, error: true, loadingLocationEmployees: false, locationEmployees: [],
      };
    case actionTypes.EMPLOYEE_FILTER_LIST_RESET_NZ:
      return {
        ...state, error: false, loadingLocationEmployees: false, locationEmployees: null,
      };
    case actionTypes.EMPLOYEE_LIST_ARL_FETCH_REQUEST_NZ:
      return { ...state, error: true, loadingBusinessEmployees: true };
    case actionTypes.EMPLOYEE_LIST_ARL_FETCH_SUCCESS_NZ:
      return {
        ...state, loadingBusinessEmployees: false, businessEmployees: action.payload,
      };
    case actionTypes.EMPLOYEE_LIST_ARL_FETCH_FAILURE_NZ:
      return {
        ...state,
        businessEmployees: [],
        loadingBusinessEmployees: false,
      };
      /** *********************************************************************** */
    case actionTypes.EMPLOYEES_DELETE_REQUEST_NZ:
      return { ...state, loading: true };
    case actionTypes.EMPLOYEES_DELETE_SUCCESS_NZ:
      return { ...state, loading: false };
    case actionTypes.EMPLOYEES_DELETE_FAILURE_NZ:
      return { ...state, loading: false };
    /** *********************************************************************** */
    case actionTypes.EMPLOYEE_EDIT_REQUEST_NZ:
      return { ...state, loading: true };
    case actionTypes.EMPLOYEE_EDIT_SUCCESS_NZ:
      return { ...state, loading: false };
    case actionTypes.EMPLOYEE_EDIT_FAILURE_NZ:
      return { ...state, loading: false };
      /** *********************************************************************** */
    case actionTypes.CREATE_ALERT_NZ:
      return {
        ...state,
        error: false,
        loading: false,
        alerts: [...state.alerts.filter(alert => alert.id !== action.id), {
          message: action.message, type: action.alertType, intent: action.alertIntent, autoDismiss: action.autoDismiss, id: action.id,
        }],
      };
    /** *********************************************************************** */
    case actionTypes.CLEAR_ALERT_NZ:
      return { ...state, alerts: [...state.alerts.filter(alert => alert.id !== action.id)] };
    /** *********************************************************************** */
    case actionTypes.CLEAR_ALL_ALERTS_NZ:
      return { ...state, alerts: [...state.alerts.filter(alert => alert.alertIntent !== action.alertIntent)] };
    /** *********************************************************************** */
    case actionTypes.EMPLOYEE_INVITE_REQUEST_NZ:
      return {
        ...state, loading: true, employeeId: action.employeeId,
      };
    case actionTypes.EMPLOYEE_INVITE_SUCCESS_NZ:
      return { ...state, loading: false };
    case actionTypes.EMPLOYEE_INVITE_FAILURE_NZ:
      return { ...state, loading: false };
    /** *********************************************************************** */
    case actionTypes.EMPLOYEES_ADD_REQUEST_NZ:
      return {
        ...state,
        loading: true,
        businessId: action.businessId,
        employeeData: action.employee,
      };
    case actionTypes.EMPLOYEES_ADD_SUCCESS_NZ:
      return {
        ...state, loading: false, businessId: action.businessId, locationData: action.location, locationName: action.locationName,
      };
    case actionTypes.EMPLOYEES_ADD_FAILURE_NZ:
      return {
        ...state, error: true, loading: false, businessId: action.businessId, uri: action.uri, locationData: action.location,
      };
    /** *********************************************************************** */
    case actionTypes.LOCATION_RESET_NZ:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
